/**
 * @file 支店選択フィールドコンポーネント
 * @description TextFieldとBranchSelectionModalを組み合わせた再利用可能なコンポーネントです。
 */

import { useState } from 'react';
import { TextField, InputAdornment, SxProps, Theme } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { BranchSelectionModal } from './BranchSelectionModal';

interface BranchSelectFieldProps {
  value: string;
  onChange: (branch: string) => void;
  error?: boolean;
  helperText?: string;
  disabled?: boolean;
  placeholder?: string;
  variant?: 'standard' | 'outlined' | 'filled';
  sx?: SxProps<Theme>;
  fullWidth?: boolean;
  required?: boolean;
  [key: string]: any; // その他TextFieldの標準props
}

export const BranchSelectField: React.FC<BranchSelectFieldProps> = ({
  value,
  onChange,
  error,
  helperText,
  disabled,
  placeholder = '支店を選択してください',
  variant = 'standard',
  sx,
  fullWidth,
  required,
  ...textFieldProps
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleSelectBranch = (branchName: string) => {
    onChange(branchName);
    setIsModalOpen(false);
  };

  return (
    <>
      <TextField
        value={value}
        onClick={() => !disabled && setIsModalOpen(true)}
        placeholder={placeholder}
        variant={variant}
        error={error}
        helperText={helperText}
        disabled={disabled}
        fullWidth={fullWidth}
        required={required}
        InputProps={{
          readOnly: true,
          endAdornment: (
            <InputAdornment position="end">
              <ExpandMoreIcon />
            </InputAdornment>
          ),
        }}
        sx={{
          ...sx,
          '& .MuiInputBase-input': {
            cursor: disabled ? 'default' : 'pointer',
          },
        }}
        {...textFieldProps}
      />
      <BranchSelectionModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSelect={handleSelectBranch}
      />
    </>
  );
};
